<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>
                <!-- header info -->
                <v-row class="pa-4 pb-0">
                    <h3>Copy user tasks from</h3>
                </v-row> 
                <v-row class="pa-4 pb-0">
                    <h5>{{ gebr_code }} : {{ gebr_naam }}</h5>
                </v-row>
                <v-row class="pa-4 pb-0">
                    <h3>To user</h3>
                </v-row> 
                <v-row class="pa-4 pb-0">
                    <h5>{{ destination }}</h5>
                </v-row>
                <v-row>
                    <v-col cols="8">
                        <v-text-field v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail/>
                    </v-col>
                </v-row> 
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="px-0" >
                            <ul class="ul_style">
                                <li>
                                    <v-data-table 
                                        dense 
                                        hide-default-footer
                                        show-select
                                        return-object
                                        :single-select=true

                                        v-model="selected_users"

                                        :headers="getHeaders()" 
                                        :search="search"
                                        :items="all_users"
                                        item-key="gebr_code"
                                        :disable-pagination=true>
                                    </v-data-table>
                                </li>
                            </ul>
                        </v-card> 
                    </v-col>
                </v-row>
                <v-row class="pa-0 pb-0 pt-2">
                    <v-col cols="1" class="pa-0 pl-4 pb-0">Merge:</v-col>
                    <v-col cols="11" class="pa-0 pl-4 pb-0">Add tasks to the user</v-col>
                </v-row>
                <v-row class="pa-0 pb-0">
                    <v-col cols="1" class="pa-0 pl-4 pb-0">Replace:</v-col>
                    <v-col cols="11" class="pa-0 pl-4 pb-0">Remove all tasks from user and copy tasks to user</v-col>
                </v-row> 
                <v-row class="pa-4 pb-2">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" class="pr-5" small v-on:click="copyUserAuth(true)" :disabled="selected_users.length === 0">Merge</v-btn>
                    &nbsp;
                    <v-btn color="primary" class="pr-5" small v-on:click="copyUserAuth(false)" :disabled="selected_users.length === 0">Replace</v-btn>
                    &nbsp;
                    <v-btn color="primary" small v-on:click="closeSelect">Close</v-btn> 
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
        },             
        data() {
            return {
                destination: "Select a user",
                gebr_encrid: "",
                gebr_code: "",
                gebr_naam: "",
                search: "",
                all_users: [],
                selected_users: [],
                dialog: false,
            }
        },
        watch: {
            selected_users(value) {
                if (value.length === 0) {
                    this.destination = "Select a user";
                } else {
                    this.destination = value[0].gebr_code + " : " + value[0].gebr_naam;
                }

            }
        },
        methods: {  
            getTaakUser() {
                this.$axios.post("ares/json/ares/syst/authorization/getTaakUser.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getTaakUser"
                    },
                    getTaakUser: {
                        taak_encrid: this.taak_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.dialog = false;
                    } else {
                        this.all_users = res.data.getTaakUser;

                        this.selected_users = [];

                        this.dialog = true;
                    }
                });
            },    
            openSelect(user) {
                this.gebr_encrid = user.gebr_encrid;
                this.gebr_code = user.gebr_code;
                this.gebr_naam = user.gebr_naam;
                this.search = "";
                this.getTaakUser();
            },
            copyUserAuth(merge) {
                this.$axios.post("ares/json/ares/syst/authorization/cpyUserTaak.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "cpyUserTaak"
                    },
                    cpyUserTaak: {
                        gebr_encrid: this.gebr_encrid,
                        user_encrid: this.selected_users[0].gebr_encrid,
                        merge: merge,
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        // User update, update parent, but stay in dialog
                        this.$emit("updateData"); 
                    }
                });
            },
            closeSelect() {
                this.dialog = false;
            },
            getHeaders() {
                return [
                    { text: "User", value: "gebr_code", sortable: true},
                    { text: "Name", value: "gebr_naam", sortable: false},
                    { text: "Actief", value: "gebr_actief", sortable: false},
                ];
            },	            
        },
    }

</script>

<style scoped>
    .row-pointer {
      cursor: pointer;
    }
    .button-margin-lr{
        margin-left: 4px;
        margin-right: 4px;
    }
    .button-margin-l{
        margin-left: 4px;
    }  
    .button-margin-r{
        margin-right: 6px;
    }  
    .gridbutton:hover{
        border: 1px solid rgba(169, 169, 169, 1) !important;
    }
	.flex{
		display: flex;
		flex-direction: row;
		align-items: center;
	}
    .ul_style {
        list-style-type: none;
        /* Remove bullets */
        padding: 0;
        /* Remove padding */
        margin: 0;
        /* Remove margins */
        height: 315px;
        overflow-y: auto;
    }
</style>